var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EDF1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v6l4 2m6-2c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10z",
    stroke: "#476FF2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC4wMDAxMjIwNyIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiByeD0iMjIiIGZpbGw9IiNFREYxRkMiLz4KPHBhdGggZD0iTTIyIDE2LjAwMDFWMjIuMDAwMUwyNiAyNC4wMDAxTTMyIDIyLjAwMDFDMzIgMjcuNTIzIDI3LjUyMjggMzIuMDAwMSAyMiAzMi4wMDAxQzE2LjQ3NzIgMzIuMDAwMSAxMiAyNy41MjMgMTIgMjIuMDAwMUMxMiAxNi40NzczIDE2LjQ3NzIgMTIuMDAwMSAyMiAxMi4wMDAxQzI3LjUyMjggMTIuMDAwMSAzMiAxNi40NzczIDMyIDIyLjAwMDFaIiBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgCircleClock as ReactComponent };